/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
     FetchGroups({commit},payload) {
        return http.get("groups_select", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                var all = response.DATA
                all.unshift({ID:"-1",name:'ALL'})
                commit('SetGroup',response.DATA);
            } 
            return response;
        });
    },
    FetchGroupsUser({commit},payload) {
        return http.get("groups_select_user", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                var all = response.DATA
                all.unshift({ID:"-1",name:'ALL'})
                commit('SetGroupUser',response.DATA);
            } 
            return response;
        });
    },
    FetchGroupsUserMap({commit},payload) {
        return http.get("group/user", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                auth.set_groups(response.DATA);
                commit('SetIdMainGroup',response.DATA[0]['ID']);
            } 
            return response;
        });
    },
};
export default actions;